import { theme } from 'ant-design-vue';

export const colors = {
    colorPrimary: '#018c01',
    infoColor: '#1677ff',
    warningColor: '#faad14',
    errorColor: '#ff4d4f',
    successColor: '#52c41a',
    confirmColor: '#faad14',
};

export default {
    token: {
        ...colors,
        borderRadius: 5,
        wireframe: false,
        algorithm: [ theme.darkAlgorithm ],
    },
};
